import { render, staticRenderFns } from "./ServicesBoard.vue?vue&type=template&id=91860c68&scoped=true&"
import script from "./ServicesBoard.vue?vue&type=script&lang=ts&"
export * from "./ServicesBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesBoard.vue?vue&type=style&index=0&id=91860c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91860c68",
  null
  
)

export default component.exports